import React from 'react';
import classNames from 'classnames';
import { Body } from '@components/text';
import './Metadata.scss';

export interface MetadataProps {
  /** style of the metadata field */
  variant?: 'minimal' | 'solid' | 'outlined';
  /** size of the text. default large */
  size?: 'small' | 'medium' | 'large';
  /** Opt-in override for the body text casing. Defaults to the brand's `--typography-metadata-text-case` token. */
  textCase?: 'uppercase' | 'lowercase' | 'capitalize' | 'none';
  /** text content */
  children?: React.ReactNode;
  /** additional class name */
  className?: string;
}

/**
 * Metadata component - a styled text field
 * @param variant - style of the metadata field
 * @param size - size of the text. default large
 * @param textCase - override for the body text casing
 * @param children - text content
 * @param className - additional class name
 */
export const Metadata: React.FC<MetadataProps> = ({
  variant = 'minimal',
  size = 'large',
  textCase,
  children,
  className,
}) => {
  const bodyColor = variant === 'solid' || variant === 'minimal' ? 'label-primary' : 'secondary';
  const bodyWeight = variant === 'solid' ? 'bold' : 'semibold';

  return (
    <div
      className={classNames(
        'vds-metadata',
        `vds-metadata--${variant}`,
        `vds-metadata--${size}`,
        textCase && `vds-metadata--text-case-${textCase}`,
        className,
      )}>
      <Body
        variant="metadata"
        size={size}
        weight={bodyWeight}
        color={bodyColor}
        className="vds-metadata__body">
        {children}
      </Body>
    </div>
  );
};
